/**
 * 数据迁移层 — schemaVersion 驱动的逐版本迁移
 *
 * 所有历史数据（localStorage / 云端）在加载时先经过 migrateData 规范化，
 * 为数据结构演进（v1→v2…）提供固定入口：只需在 MIGRATIONS 数组追加一个迁移函数，
 * 不再需要散落各处的兼容补丁（如 archive.info 回退这类一次性处理）。
 *
 * 约定：
 * - MIGRATIONS[i] 表示把数据从 v(i) 迁移到 v(i+1)
 * - 数据顶层 schemaVersion 缺省视为 0（旧数据）
 * - migrateData 返回新对象，不修改入参
 */
import { getToday } from './helpers/dates.js';

function defaultSelfHotel() {
  return {
    name: '', area: '', star: '', rooms: '', occupancy: '', efficiency: '',
    utilization: 0, adr: '', coverNote: '', createdAt: '', roomTypes: {}, history: {}
  };
}

// v0 → v1：无版本号旧数据 → 规范化 v1 结构
function toV1(raw) {
  const d = Object.assign({}, raw);
  d.schemaVersion = 1;
  if (!d.archives || typeof d.archives !== 'object' || Array.isArray(d.archives)) d.archives = {};
  if (d.currentArchive === undefined) d.currentArchive = null;
  if (!d.currentTime) d.currentTime = 'morning';
  if (!d.selectedDate) d.selectedDate = getToday();
  if (!d.selfHotel || typeof d.selfHotel !== 'object' || Array.isArray(d.selfHotel)) {
    d.selfHotel = defaultSelfHotel();
  } else {
    if (!d.selfHotel.roomTypes || typeof d.selfHotel.roomTypes !== 'object') d.selfHotel.roomTypes = {};
    if (d.selfHotel.adr === undefined) d.selfHotel.adr = '';
    if (!d.selfHotel.history || typeof d.selfHotel.history !== 'object') d.selfHotel.history = {};
  }
  return d;
}

const MIGRATIONS = [toV1];

export function migrateData(raw) {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) {
    return toV1({});
  }
  const version = Number(raw.schemaVersion) || 0;
  let data = raw;
  for (let v = version; v < MIGRATIONS.length; v++) {
    data = MIGRATIONS[v](data);
  }
  return data;
}
